module.exports = __webpack_public_path__ + "img/banner2_tv.08295bb6.png";